import React from 'react';
import { connect } from 'react-redux';
import { I18nextProvider } from 'react-i18next';

interface TranslationLockProps {
  i18nData: any;
}

const mapStateToProps = (state) => ({
  i18nData: state.i18nData,
});

export const withLockedTranslation = <P extends any>(
  Component: React.ComponentType<P>,
): React.ComponentType<P> => {
  class TranslationLock extends React.Component<P & TranslationLockProps> {
    render() {
      const { i18nData, ...props } = this.props;
      return (
        <I18nextProvider i18n={i18nData}>
          <Component {...(props as P)} />
        </I18nextProvider>
      );
    }
  }

  return connect(mapStateToProps)(TranslationLock) as React.ComponentType<P>;
};
